import { EventEmitter } from "@stencil/core";

export const saveUrlInCookie = (urlHistorySet: EventEmitter) => {
    let cookieContent = getCookieValue("backlink_referrer");

    let cookieArray: any[] = [];
    let backlinkReferrer: {
        id: string;
        link: string;
        title: string;
        L?: string;
    } = null;
    let language = null;

    if (!cookieContent) {
        backlinkReferrer = {
            //@ts-expect-error FIXME
            id: window.pageId,
            link: location.href,
            title: document.title,
        };
        language = getCookieValue("language_iso");
        if (typeof language !== "undefined") backlinkReferrer["L"] = language;
        //@ts-expect-error FIXME
        cookieArray = window.pageId ? [backlinkReferrer] : null;
        if (!cookieArray) return;
        writeCookie(cookieArray);
        return;
    }

    cookieContent = decodeURIComponent(cookieContent);

    if (isJsonLike(cookieContent)) {
        cookieArray = getArrayValuesFromCookie(cookieContent);

        //@ts-expect-error FIXME
        backlinkReferrer = window.pageId
            ? {
                  //@ts-expect-error FIXME
                  id: window.pageId,
                  link: location.href,
                  title: document.title,
              }
            : null;

        console.log(cookieArray[0], backlinkReferrer);

        language = getCookieValue("language_iso");
        if (typeof language !== "undefined") backlinkReferrer["L"] = language;

        // check if the last entry of the cookie array is exists, the new entry exists and checks that either their id or language (L) are different
        if (
            cookieArray[0] &&
            backlinkReferrer &&
            (cookieArray[0]["id"] !== backlinkReferrer["id"] ||
                cookieArray[0]["L"] !== backlinkReferrer["L"])
        ) {
            // inserts the new element first
            cookieArray.unshift(backlinkReferrer);

            if (cookieArray.length > 2) cookieArray.pop();

            writeCookie(cookieArray);
        }

        if (cookieArray.length === 2) {
            urlHistorySet.emit({
                cookieArray: cookieArray,
            });
        }
    }
};

function writeCookie(cookieArray: string[]) {
    const cookieJson = JSON.stringify(cookieArray);
    const win = window as { cookieDomain?: string };
    if (typeof win.cookieDomain !== "undefined") {
        document.cookie = `backlink_referrer=${encodeURIComponent(
            cookieJson
        )};SameSite=Strict;Path=/;domain=${win.cookieDomain}`;
    }
}

export function setGoBackLink(
    configureElement: (visible: boolean, title: string, href: string) => void
) {
    let cookieContent = getCookieValue("backlink_referrer");
    if (typeof cookieContent === "undefined") return;
    cookieContent = decodeURIComponent(cookieContent);
    if (isJsonLike(cookieContent)) {
        const cookieArray = JSON.parse(decodeURIComponent(cookieContent));
        if (typeof cookieArray[1] !== "undefined") {
            configureElement(
                true,
                decodeURIComponent(cookieArray[1].title),
                cookieArray[1].link
            );
        }
    }
}

function getCookieValue(cookieName: string): string {
    const cookieValue = document.cookie.match(
        `(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`
    );
    return cookieValue ? cookieValue.pop() : "";
}

function isJsonLike(str: string): boolean {
    const jsonStartstring = str.match(/^\[|^\{(?!\{)/);
    return (
        jsonStartstring &&
        {
            "[": /]$/,
            "{": /}$/,
        }[jsonStartstring[0]].test(str)
    );
}

function getArrayValuesFromCookie(cookieContent: string): any[] {
    const cookieArray = JSON.parse(cookieContent);
    return cookieArray.map((value) =>
        typeof value === "object" ? value : JSON.parse(value)
    );
}
